import { Col, Row } from 'antd';
import * as React from 'react';
import { RouteProps } from 'react-router-dom';
import styled from 'styled-components';
import ConfirmJointHolderForm from '../../components/Client/ConfirmJointHolderForm/ConfirmJointHolderForm';
import NotificationService from '../../Core/NotificationService';// 'Core/NotificationService';
import { ConfirmJointHolderFormHandler } from '../../components/Client/ConfirmJointHolderForm/ConfirmJointHolderFormHandler';
import { ConfirmJointHolderFormModel } from '../../components/Client/ConfirmJointHolderForm/Models/ConfirmJointHolderFormModel';
import queryString from 'query-string';
import { Redirect } from 'react-router';


export interface Props extends RouteProps {
  children?: React.ReactNode;
}

export interface State {
  isConfirmed: boolean;
}

const TallCol = styled(Col)`
  height: 100%;
  min-height: 200px;
`;

export default class ConfirmJointHolderPage extends React.Component<Props, State> {
    confirmJointHolderFormHandler: ConfirmJointHolderFormHandler;


  constructor(props: Props) {
    super(props);
      this.confirmJointHolderFormHandler = new ConfirmJointHolderFormHandler(props);

    this.state = { isConfirmed: false };
  }

  componentDidMount() {
    const values = queryString.parse(this.props?.location?.search)
    //  this.confirmJointHolderFormHandler.ConfirmEmail(values.email, values.token).then(x => {
    //  NotificationService.success(
    //    'Email Confirmed',
    //    <>
    //      <p>
    //        Your email address has been confirmed.
    //      </p>
    //    </>, undefined, true
    //  );
    //  // setTimeout(() => { this.setState({ isConfirmed: true }); }, 15000);
    //  this.setState({ isConfirmed: true });

    //  return x;
    //});

    //let state: { from?: string; noPermission?: boolean } = {};

  }

  render() {
    if (this.state.isConfirmed) {
      return <Redirect to="/login" />;
    }

    return (
      <Row type="flex" align="middle">
        <TallCol xs={12} sm={12} md={8}>
                <h3>Confirm Joint Holder</h3>
                <ConfirmJointHolderForm {...this.props} />
        </TallCol>
      </Row>
    );
  }
}






